var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useEffect, useState } from 'react';
import * as Modal from 'react-modal';
import { fetchApi, generateRoute, translate } from '@js/common/helpers';
import { getSegment } from '@js/common/paywallSegment';
import { initModalAnalytics } from '@js/paywall_tts';
import { HttpMethods } from 'tagwalk-api-client/assets/js/common/enums';
import { SubscriptionsStoreInstance } from '@ts/common/service-instance/SubscriptionsStoreInstance';
var body = document.querySelector('body');
if (body) {
    Modal.setAppElement(body);
}
export function imageSearchContext(catalog) {
    return catalog ? 'image-similarity-catalog' : 'image-similarity';
}
export function ImageSearchPaywallModal(props) {
    var _a = useState('free-user'), segment = _a[0], setSegment = _a[1];
    useEffect(function () {
        if (!props.isOpen) {
            return;
        }
        SubscriptionsStoreInstance.getPaywallSubscription().then(function (subscription) {
            var resolvedSegment = subscription ? getSegment(subscription) : 'free-user';
            setSegment(resolvedSegment);
            initModalAnalytics(imageSearchContext(props.catalog), resolvedSegment);
        });
    }, [props.isOpen]);
    var subscribeUrl = generateRoute('membership_index', {
        utm_source: imageSearchContext(props.catalog),
        utm_content: segment,
        need_login: 'no',
    });
    var loginUrl = generateRoute('auth_index', {
        sign_in: 'true',
    });
    function switchAccount(event) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4, fetchApi('security_request_authentication', HttpMethods.get, {
                                route: 'auth_index',
                                params: { show_auth: true, sign_in: true },
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            window.location.href = response.url;
                            return [2];
                        }
                        window.location.href = loginUrl;
                        return [2];
                }
            });
        });
    }
    return (React.createElement(Modal, { isOpen: props.isOpen, onRequestClose: props.onClose, className: "image-search-modal tds", overlayClassName: "image-search-modal-overlay backdrop" },
        React.createElement("div", { className: "image-search-modal-header" },
            React.createElement("h2", { className: "image-search-modal-title" }, translate('image_search.modal_title')),
            React.createElement("button", { type: "button", className: "image-search-modal-close", onClick: props.onClose, "aria-label": translate('image_search.close') },
                React.createElement("i", { className: "iconoir-xmark" }))),
        React.createElement("div", { className: "image-search-modal-body image-search-paywall" },
            React.createElement("span", { className: "image-search-paywall-badge pill" }, translate('image_search.beta')),
            React.createElement("i", { className: "iconoir-lock image-search-paywall-icon", "aria-hidden": "true" }),
            React.createElement("p", { className: "image-search-paywall-eyebrow" }, translate('image_search.paywall.eyebrow')),
            React.createElement("h3", { className: "image-search-paywall-title" }, translate('image_search.paywall.title')),
            React.createElement("p", { className: "image-search-paywall-text" }, translate('image_search.paywall.text')),
            React.createElement("a", { className: "btn", href: subscribeUrl }, translate('image_search.paywall.subscribe')),
            React.createElement("p", { className: "image-search-paywall-login" },
                translate('image_search.paywall.login'),
                " ",
                React.createElement("a", { href: loginUrl, onClick: props.logged ? switchAccount : undefined }, translate(props.logged ? 'image_search.paywall.switch_link' : 'image_search.paywall.login_link'))))));
}
